import { StoryblokImageTextSection } from './StoryblokImageTextSection'

import { createImageTextSection } from './__mocks__/imageTextSection'

export { createImageTextSection }

// Re-export for backward compatibility
export const dummyImageTextSectionBlok = createImageTextSection()

export default StoryblokImageTextSection
